<!--
 * @Description:客户详情底部按钮
 * @Author: cxh
 * @Date: 2022-09-20 15:19:34
 * @LastEditTime: 2022-09-20 17:11:21
 * @LastEditors: cxh
-->
<template>
  <cos-footer-button :loading="loading" hideOk>
    <a-button type="primary" @click="handleTungee">同步探迹信息</a-button>
    <a-button @click="handleTransfer" v-permission="permissionPage?.transfer">转移客户</a-button>
    <a-button @click="handleAddConcat" v-permission="permissionPage?.concat_add">新增联系人</a-button>
    <a-button @click="handleAddFollow" v-permission="permissionPage?.follow_add">写跟进</a-button>
    <a-button @click="hanleVisitor" v-permission="permissionPage?.visitor_add">新增访客计划</a-button>
    <SellerButton controlType="none" :workCode="workCode" @click="handleAddBuss" v-permission="permissionPage?.buss_add"
      >新增商机</SellerButton
    >
    <a-button type="primary" @click="handleEdit" v-permission="permissionPage?.edit">编辑</a-button>
  </cos-footer-button>
  <!--转移客户--->
  <TransferModel ref="transferModelRef" @success="successPage('base')" />
  <!--新增联系人--->
  <ConcatModal ref="concatModalRef" @success="successPage('contact')" :contactRefId="route.query.cosId" />
</template>
<script setup lang="ts">
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import TransferModel from './transferModel.vue'
import ConcatModal from '@/components/TabsContacts/lbu/editModal.vue'
import request from '@/utils/request'
import { DcMessage } from '@dc-platform/dc-components'
const transferModelRef = ref()
const concatModalRef = ref()
const router = useRouter()

const route = useRoute()
const emit = defineEmits(['success'])
const props = defineProps({
  workCode: {
    type: String
  },
  customerName: {
    type: String
  },
  type: {
    type: String
  },
  loading: {
    type: Boolean
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  }
})
// 转移客户
const handleTransfer = () => {
  transferModelRef.value.toggle([{ cosId: route.query.cosId }])
}
// 新增联系人
const handleAddConcat = () => {
  concatModalRef.value.toggle()
}
// 新增访客计划
const hanleVisitor = () => {
  router.push({
    path: '/lbu/visitorProgram/add',
    query: {
      saleChanceRefId: route.query.cosId
    }
  })
}
// 转移客户和新增联系人成功回调
const successPage = (tag: any) => {
  emit('success', tag)
}
// 新增跟进记录
const handleAddFollow = () => {
  router.push({
    path: '/lbu/followUpRecord/add',
    query: {
      followRefId: route.query.cosId
    }
  })
}
// 新增商机
const handleAddBuss = () => {
  router.push({
    path: '/lbu/business/add',
    query: {
      saleChanceRefId: route.query.cosId
    }
  })
}

const handleTungee = () => {
  request
    .post('lbu/api/tungee/customer/sync', { cosId: route.query.cosId, customerName: props.customerName })
    .then((res) => {
      if (res.code === 200) {
        successPage('tungee')
        DcMessage.success('数据同步中，请稍后查看')
      } else {
        DcMessage.error(res?.message)
      }
    })
}
//  编辑
const handleEdit = () => {
  let path = ''
  if (props.type === 'clients') {
    path = '/lbu/clients/edit'
  } else if (props.type === 'potential') {
    path = '/lbu/potential/edit'
  }
  if (path) {
    router.push({
      path,
      query: {
        cosId: route.query.cosId
      }
    })
  }
}
</script>
<script lang="ts">
export default { name: 'viewFooterBtn' }
</script>
